import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class ReportTemplates extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'ReportTemplates'
  // Define default properties here
  static instanceDefaults () {
    return {
      title: null,
      data: null,
      isFrameworkDefault: false,
      visibility: 'private',
    }
  }
}
const servicePath = 'report-templates'
const servicePlugin = makeServicePlugin({
  Model: ReportTemplates,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
